import { useTranslations } from "next-intl";
import { useCurrentUser, useSubscriptionEligibleTo } from "@hooks/use-current-user";
import { useOpenDrawer } from "@hooks/use-drawer";
import { useFormatDate } from "@hooks/use-format-date";
import Button from "@components/core/Button";

function ClosetUnlockEarly() {
  const t = useTranslations("closets");

  const user = useCurrentUser();
  const subscriptionEligibleTo = useSubscriptionEligibleTo();
  const formatDate = useFormatDate();
  const nextInvoiceDate = user.next_invoice_date;

  const openDrawer = useOpenDrawer();

  if (subscriptionEligibleTo !== "unlock_early") return null;

  return (
    <div className="pb-4">
      <p>{t("unlock_early.next_invoice_info", { date: formatDate(nextInvoiceDate) })}</p>

      <Button
        variant="primary"
        onClick={openDrawer}
      >
        {t("unlock_early.button")}
      </Button>
    </div>
  );
}

export default ClosetUnlockEarly;
